<template>
  <div class="dashboard">
    <el-container>
      <el-header>
        <el-button class="header-btn pull-right"
                   type="primary"
                   icon="el-icon-circle-plus"
                   @click="createTask"> Create New Task</el-button>
        <h2 class="card-title">Dashboard</h2>
        <week-total-tags :user="currentUser" />
      </el-header>
      <el-main class="panels">
        <div class="wrap">
          <task-timer title="Timer"
                      v-if="currentUser" />
          <log-list :title="logListView === 'week' ? 'This Week\'s Logs' : 'Today\'s Logs'"
                    :show-client-code="true"
                    :show-total-time="true"
                    :show-comment="false"
                    :show-task-project-name="true"
                    :show-task-date="false"
                    :group-logs-by-date="logListView === 'week'"
                    :logs="userLogs"
                    :title-click-handler="toggleLogListView"
                    v-if="currentUser" />
        </div>

        <task-list title="Your Tasks"
                   :show-client-code="true"
                   :show-start-button="true"
                   :sortable="true"
                   :tasks="userTasks"
                   :user="currentUser"
                   v-if="currentUser" />

      </el-main>
    </el-container>

    <task-crud v-if="showTaskCrud"
               @close="taskCrudClose" />
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'dashboard',
  components: {},
  data () {
    return {
      showTaskCrud: false
    }
  },
  methods: {
    createTask () {
      this.showTaskCrud = true
    },
    taskCrudClose (task) {
      // Handle the Project Crud Dialog closing
      this.showTaskCrud = false

      if (task) {
        this.$router.push({name: 'task', params: { task_id: task.id }})
      }
    },
    toggleLogListView () {
      // Toggle the Log List between day and week view
      if (this.logListView === 'day') {
        this.$store.dispatch('setDashboardLogListView', 'week')
      } else {
        this.$store.dispatch('setDashboardLogListView', 'day')
      }
    }
  },
  computed: {
    userTasks () {
      // Return all logs related to the current user, that happened today
      var tasks = []
      if (this.currentUser) {
        tasks = Object.keys(this.tasks).map((k) => this.tasks[k]).filter(function (item) {
          // Only return tasks belonging to the current user, that aren't complete (1) or cancelled (6)
          if (item.group_task) {
            return item.group_users.indexOf(this.currentUser.id) !== -1 && item.status !== 1 && item.status !== 6
          } else {
            return item.user_id === this.currentUser.id && item.status !== 1 && item.status !== 6
          }
        }.bind(this))
      }
      return tasks
    },
    userLogs () {
      // Return all logs related to the current user, that happened today
      var logs = []
      if (this.currentUser) {
        logs = Object.keys(this.logs).map((k) => this.logs[k]).filter(function (item) {
          if (item.user_id === this.currentUser.id && item.end) {
            // If the log end date is today, all converted to UTC for accuracy
            return moment.utc(item.end).local().isSame(moment(), this.logListView)
          }
        }.bind(this))
      }
      return logs
    },

    // Vuex Mappings
    currentUser () {
      return this.$store.state.users.currentUser
    },
    logs () {
      return this.$store.state.logs.objects
    },
    tasks () {
      return this.$store.state.tasks.objects
    },
    logListView () {
      return this.$store.state.filters.dashboardLogListView
    }
  },
  mounted () {
    this.$store.dispatch('setPageTitle', 'Dashboard')
    this.$store.dispatch('getCurrentUser')
  },
  watch: {
    'currentUser' () {
      if (this.currentUser) {
        this.$store.dispatch('getUsers')
        this.$store.dispatch('getProjects')
        this.$store.dispatch('getClients')
        this.$store.dispatch('getTasks', {user_id: this.currentUser.id})
        this.$store.dispatch('getLogs', {user_id: this.currentUser.id, active: true})
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .dashboard {
    .wrap {
      > .panel {
        padding: 5px;
        @media screen and (min-width: 767px) {
          padding: 10px;
        }
      }
    }
    @media screen and (min-width: 1020px) {
      .task-list {
        order: 0;
      }
      .wrap {
        order: 1;
        > .panel {
          padding: 10px;
        }
      }
      > .panel,
      .wrap {
        flex-basis: 50%;
        width: 50%;
      }
      .task-timer {
      }
    }
  }
</style>
